import parametersBenefits from '../../../../../assets/images/reg-guide/parameters.png';
import location from '../../../../../assets/images/reg-guide/location.png';
import lensesCare from '../../../../../assets/images/reg-guide/lenses-care.png';
import learning from '../../../../../assets/images/reg-guide/learning.png';
import { IBenefitProps } from './benefit';

export const benefits: IBenefitProps[] = [{
  item: 'regGuide.ecp.benefits.list.benefit1',
  icon: <img width={110} height={82} alt="" src={parametersBenefits} />,
}, {
  item: 'regGuide.ecp.benefits.list.benefit2',
  icon: <img width={110} height={82} alt="" src={location} />,
}, {
  item: 'regGuide.ecp.benefits.list.benefit3',
  icon: <img width={110} height={82} alt="" src={lensesCare} />,
}, {
  item: 'regGuide.ecp.benefits.list.benefit4',
  icon: <img width={110} height={82} alt="" src={learning} />,
}];
